import React from 'react';
import { useTranslation } from 'react-i18next';

type StepStatus = 'done' | 'current' | 'pending';

const statuses: StepStatus[] = ['done', 'done', 'done', 'current', 'pending', 'pending'];
const statusIcon: Record<StepStatus, string> = { done: '✓', current: '●', pending: '○' };

const CoachingSlide: React.FC = () => {
  const { t } = useTranslation();
  const m = t('demoTour.mockups.coaching', { returnObjects: true }) as any;

  return (
    <div className="dt-mockup-coaching">
      <div className="dt-coaching-header">
        <div className="dt-coaching-avatar">MK</div>
        <div>
          <div className="dt-coaching-name">{m.clientName}</div>
          <div className="dt-coaching-badge">{m.clientBadge}</div>
        </div>
      </div>
      <div className="dt-coaching-steps">
        {m.steps.map((step: any, i: number) => {
          const status = statuses[i];
          return (
            <div key={i} className={`dt-coaching-step dt-coaching-step--${status}`}>
              <div className="dt-coaching-step-icon">{statusIcon[status]}</div>
              <div className="dt-coaching-step-content">
                <div className="dt-coaching-step-label">{step.label}</div>
                <div className="dt-coaching-step-date">{step.date}</div>
              </div>
              {i < m.steps.length - 1 && <div className="dt-coaching-step-line" />}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CoachingSlide;
